import React, { useState } from "react";
import { Droppable } from "@hello-pangea/dnd";
import PlatformLeadCard from "./PlatformLeadCard";

const PlatformPipelineColumn = ({ stage, leads = [], onCardClick, isTerminal = false }) => {
    const [collapsed, setCollapsed] = useState(isTerminal);

    return (
        <div className={`crm-kanban-column stage-${stage.key} ${collapsed ? "is-collapsed" : ""}`}>
            {/* Header */}
            <div
                className={`crm-column-header ${isTerminal ? "crm-column-header-clickable" : ""}`}
                onClick={isTerminal ? () => setCollapsed(v => !v) : undefined}
            >
                <span className="crm-column-title" title={stage.label}>
                    {stage.label}
                </span>
                <div className="d-flex align-items-center gap-2">
                    <span className="badge rounded-pill crm-column-badge">{leads.length}</span>
                    {isTerminal && (
                        <i className={`mdi mdi-chevron-${collapsed ? "down" : "up"} crm-column-chevron`} />
                    )}
                </div>
            </div>

            {/* Droppable — renderizado apenas quando expandido */}
            {!collapsed ? (
                <Droppable droppableId={stage.key}>
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className={`crm-droppable-area ${snapshot.isDraggingOver ? "dragging-over" : ""}`}
                        >
                            {leads.map((lead, idx) => (
                                <PlatformLeadCard
                                    key={lead.id}
                                    lead={lead}
                                    index={idx}
                                    onClick={onCardClick}
                                />
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            ) : (
                <div
                    className="crm-collapsed-hint"
                    onClick={() => setCollapsed(false)}
                >
                    <i className="mdi mdi-chevron-down me-1" />
                    {leads.length > 0
                        ? `Ver ${leads.length} ${leads.length === 1 ? "lead" : "leads"}`
                        : "Nenhum lead aqui"}
                </div>
            )}
        </div>
    );
};

export default PlatformPipelineColumn;
